import { Link } from "react-router-dom";
export default function Footer() {
  return (
    <footer className="border-t border-neutral-800 mt-16 px-4 md:px-8 lg:px-12 py-10 bg-appbg">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
        <div className="md:col-span-2">
          <div className="heading text-3xl">CoachConnect <span className="text-blaze">AI</span></div>
          <div className="mt-3 flex flex-wrap gap-4 text-xs tracking-widest">
            <Link to="/jobs/weekly" data-testid="footer-weekly-jobs" className="text-neutral-300 hover:text-white">WEEKLY OPENINGS</Link>
            <Link to="/pricing" data-testid="footer-pricing" className="text-neutral-300 hover:text-white">PRICING</Link>
            <Link to="/admin" data-testid="footer-admin-signin" className="text-neutral-500 hover:text-white">ADMIN SIGN IN</Link>
          </div>
          <div className="text-[10px] tracking-[0.35em] text-blaze mt-2" data-testid="footer-arena-tagline">FOR THE ONES IN THE ARENA</div>
          <p className="heading text-lg md:text-xl mt-4 leading-tight" data-testid="footer-mantra">
            The <span className="text-blaze">right coach</span>, for the <span className="text-volt">right program</span>, at the <span className="text-white">right time</span>.
          </p>
          <p className="text-neutral-300 mt-3 text-sm max-w-md leading-relaxed">
            The right coach, for the right program, at the right time. Coaches join free — programs post jobs free. Fit goes both ways.
          </p>
        </div>
        <div>
          <div className="heading text-sm text-neutral-500 mb-3">FOR COACHES</div>
          <ul className="space-y-2 text-sm text-neutral-400">
            <li>Free profile</li><li>AI-curated opportunities</li><li>Career timeline (TKG)</li>
          </ul>
        </div>
        <div>
          <div className="heading text-sm text-neutral-500 mb-3">FOR PROGRAMS</div>
          <ul className="space-y-2 text-sm text-neutral-400">
            <li>Headhunter agent</li><li>XAI match rationale</li><li>Market intelligence</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-neutral-800 mt-8 pt-6 flex items-center justify-between text-xs text-neutral-500">
        <div>© CoachConnect AI · USILA / NILCA / IMLCA partner-ready</div>
        <div className="text-mono">v0.1 · TKG ALPHA</div>
      </div>
    </footer>
  );
}
